module.exports = __webpack_public_path__ + "0adbb6646a1e26c449969a38e3bbc3ba.svg";